import { findWhere, isEmpty } from 'underscore';
import { bidStratetyTypeValue } from '@bingads-webui-campaign-react/constants';

import { CAMPAIGN_NEGATIVE_REFERENCE_ID } from '../shared/constants';

export const viewModelToModelForPredictiveMatching = (campaignViewModel, permissions) => {
  const model = {};

  // Predictive Matching
  const predictiveTargetingSetting = findWhere(campaignViewModel.CampaignSettings, { '@odata.type': '#Model.PredictiveTargetingSetting' });
  const autoTargetingDefault = (predictiveTargetingSetting && predictiveTargetingSetting.PredictiveTargetingEnabled) || false;
  const supportedBiddingStrategiesForPredictiveMatching = [
    bidStratetyTypeValue.targetCpa,
    bidStratetyTypeValue.targetRoas,
    bidStratetyTypeValue.maximizeConversions,
  ];
  const autoTargetingEnabled = supportedBiddingStrategiesForPredictiveMatching.includes(campaignViewModel.BiddingScheme.Type) && (campaignViewModel.isPredictiveMatchingChecked === undefined ? campaignViewModel.AutoTargetingEnabled : campaignViewModel.isPredictiveMatchingChecked);

  // Only sent when predictiveTargetingEnabled change
  if (!!autoTargetingEnabled !== autoTargetingDefault) {
    model.AutoTargetingEnabled = autoTargetingEnabled || false;
  }

  // Brand Protections
  if (autoTargetingEnabled && campaignViewModel.brandProtections) {
    if (!isEmpty(campaignViewModel.brandProtections.deletedBrandListIds)) {
      model.BrandListsAssociations = [
        ...model.BrandListsAssociations || [],
        ...campaignViewModel.brandProtections.deletedBrandListIds.map(brandListId => ({
          Id: brandListId, SharedEntityId: brandListId, EntityId: campaignViewModel.Id || CAMPAIGN_NEGATIVE_REFERENCE_ID, Status: 'Deleted',
        })),
      ];
    }
    if (!isEmpty(campaignViewModel.brandProtections.addedBrandListIds)) {
      model.BrandListsAssociations = [
        ...model.BrandListsAssociations || [],
        ...campaignViewModel.brandProtections.addedBrandListIds.map(brandListId => ({
          Id: brandListId, SharedEntityId: brandListId, EntityId: campaignViewModel.Id || CAMPAIGN_NEGATIVE_REFERENCE_ID, Status: 'Active',
        })),
      ];
    }
  }

  if (model.AutoTargetingEnabled && permissions && !(permissions.dynamic && permissions.dynamic.PredictiveMatching)) {
    model.AutoTargetingEnabled = false;
  }

  return model;
};
